import Swiper from 'swiper';
import { Pagination, Keyboard, Autoplay } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', function(){

    const swiperEl = document.querySelector('.reviews-swiper');

    // init swiper
    const reviewsSwiper = new Swiper(swiperEl, {
        modules: [Pagination, Keyboard, Autoplay],
        loop: true,
        spaceBetween: 0,
        keyboard: {
            enabled: true
        },
        autoplay: {
            delay: 6000,
            pauseOnMouseEnter: true
        },
        pagination: {
            el: '.reviews-swiper-pagination',
            clickable: true,
            renderBullet: function (index, className) {
                const title = this.slides[index].getAttribute('data-pagination-title') || '';
                return `
                    <div class="${className}">${title}</div>
                `;
            }
        },
        on: {
            slideChange: function(swiper){
                const activePaginationElement = swiper.pagination.el.querySelector('.swiper-pagination-bullet-active');
                const paginationWrapper = document.querySelector('.reviews-swiper-pagination');
                
                // scroll pagination wrapper to active element
                paginationWrapper.scrollTo({
                    top: activePaginationElement.offsetTop, 
                    behavior: 'smooth'
                });
            },
            afterInit: function(swiper){
                // scroll to slider viewport when pagination is cliked
                swiper.pagination.el.querySelectorAll('.swiper-pagination-bullet').forEach(bullet => {
                    bullet.addEventListener('click', () => {
                        window.scrollTo({
                            top: swiperEl.getBoundingClientRect().top + window.scrollY - (document.querySelector('#main-header').getBoundingClientRect().height + 10), 
                            behavior: 'smooth'
                        });
                    });
                });
            },
            'afterInit': function(swiper){
                // stop on load
                swiper.autoplay.stop();
            }
        }
    });

    // observe for carousel
    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if ( entry.isIntersecting && entry.intersectionRatio >= 0.5 ){
                // play when scroll on
                reviewsSwiper.autoplay.start();
            }
            else
            {
                // pause when scroll off
                reviewsSwiper.autoplay.stop();
            }
        });
    }, 
    {
        threshold: 0.5
    });

    observer.observe(swiperEl);

    /**
     * resize observer for swipers height
     * so we can set max-height for pagination
     */
    const resizeObserver = new ResizeObserver(entries => {
        for ( const entry of entries ) {

            const height = entry.borderBoxSize?.[0].blockSize;

            if ( typeof height === 'number' ) {
                document.querySelector('.reviews-swiper-pagination').style.setProperty('--pagination-max-height', height + "px");
            }

        }
    });

    resizeObserver.observe( swiperEl );
});